module.exports = {
  videoAudio: {
    key: 'videoAudio',
    label: 'Video Call',
  },
  audio: {
    key: 'audio',
    label: 'Audio',
  },
  dictation: {
    key: 'dictation',
    label: 'Dictation',
  },
};